module.exports = __webpack_public_path__ + "img/news1.9e211271.jpg";